import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";
import { Category } from "@builder/types/Categories.type";
import { buildUrlQuery } from "@builder/utils/buildUrlQuery";

export const categoriesApi = createApi({
    reducerPath: "categoriesApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${import.meta.env.VITE_URL_HUB_API}category`,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["categories"],
    endpoints: builder => ({
        getCategories: builder.query<Category[], { companyId: string; search?: string; skip?: number; limit?: number; organizationId?: string }>({
            query: ({ companyId, search, skip, limit, organizationId }) =>
                `/builder/query/${companyId}?${buildUrlQuery({ search, skip, limit, organizationId })}`,
            providesTags: ["categories"]
        }),
        getCategoriesByIds: builder.query<Category[], { companyId: string; ids: string[]; organizationId?: string }>({
            query: ({ companyId, ids, organizationId }) => {
                const params = new URLSearchParams({ ids: ids.join(",") });
                if (organizationId) {
                    params.append("organizationId", organizationId);
                }
                return `/builder/by-ids/${companyId}?${params.toString()}`;
            },
            providesTags: ["categories"]
        })
    })
});

export const { useGetCategoriesQuery, useGetCategoriesByIdsQuery } = categoriesApi;
